module.exports = __webpack_public_path__ + "static/img/topic-prize.26363dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/topic-prize.png
// module id = YcfZ
// module chunks = 36